var map = {
	"./blue.svg": 405,
	"./buyRight.svg": 3411,
	"./close.svg": 98179,
	"./dis.svg": 71551,
	"./icon1.svg": 65363,
	"./line.svg": 65267,
	"./loading.svg": 90335,
	"./popupClose.svg": 77451,
	"./red.svg": 19790,
	"./text1.svg": 1805,
	"./tg.svg": 5602,
	"./title.svg": 40129,
	"./x.svg": 57355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;